import React from 'react';

const LeadJourney = () => (
  <>
    <p>
      Every publisher we speak to can describe the top of the funnel in
      detail: the placement, the creative, the click-through. Where the
      story goes fuzzy is what happens between the click and the signed
      contract. That gap is where publisher margin lives.
    </p>

    <h2>The five real stages</h2>
    <ol>
      <li>
        <strong>Click →</strong> the visitor lands on a form or gated asset.
      </li>
      <li>
        <strong>Capture →</strong> name, email, company, role, intent.
      </li>
      <li>
        <strong>Verify →</strong> is this a real person, at a real company,
        with the right authority?
      </li>
      <li>
        <strong>Enrich →</strong> what account are they part of? Which
        competing vendors do they use? Is a renewal coming?
      </li>
      <li>
        <strong>Route →</strong> the enriched lead lands in the advertiser's
        pipeline inside their SLA — often minutes, not days.
      </li>
    </ol>

    <h2>Where publishers usually break</h2>
    <p>
      Nine times out of ten, stages three and four are missing or manual.
      The publisher captures the lead, hands it over as a CSV, and hopes.
      The advertiser reciprocates by paying a display-adjacent CPL and never
      renews.
    </p>
    <p>
      The publishers who capture the margin have automated verification and
      enrichment as a system-level capability. That's the entire pitch
      behind our Enrich IQ product line — but even without a product, the
      discipline is what matters.
    </p>

    <h2>What "good" looks like on a briefing</h2>
    <p>
      A lead you would be proud to hand over looks like this:
    </p>
    <ul>
      <li>Verified corporate email &mdash; not a Gmail address</li>
      <li>Role and seniority confirmed against the person's public profile</li>
      <li>Account-level signals: renewal window, tech stack, org chart</li>
      <li>A one-line "why now" the advertiser's SDR can open a call with</li>
    </ul>
    <p>
      That level of dossier is what your advertiser expects from their own
      SDR team after fifteen minutes of manual research. Deliver it in
      seconds and at scale, and you own the renewal conversation.
    </p>
  </>
);

export default LeadJourney;
